import { render, staticRenderFns } from "./IDNumberProfessionalValidatorMixin.vue?vue&type=template&id=81142c64&lang=pug"
import script from "./IDNumberProfessionalValidatorMixin.vue?vue&type=script&lang=ts"
export * from "./IDNumberProfessionalValidatorMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81142c64')) {
      api.createRecord('81142c64', component.options)
    } else {
      api.reload('81142c64', component.options)
    }
    module.hot.accept("./IDNumberProfessionalValidatorMixin.vue?vue&type=template&id=81142c64&lang=pug", function () {
      api.rerender('81142c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/mixins/IDNumberProfessionalValidatorMixin.vue"
export default component.exports